import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { DocumentDirectoryService } from 'src/app/services/document-directory.service';
import { IPOServiceService } from './../../services/iposervice.service';
import * as FileSaver from 'file-saver';
import  JSZip from 'jszip';
import jsPDF from 'jspdf';
declare var $: any;
declare var require: any;
const FileSaver = require("file-saver");
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js'
declare var $: any;
import { DatePipe, Location } from '@angular/common';
import { isNullOrUndefined } from 'src/app/validation';
import jspdf from 'jspdf';

@Component({
  selector: 'app-bank-covering-letter',
  templateUrl: './bank-covering-letter.component.html',
  styleUrls: ['./bank-covering-letter.component.scss']
})
export class BankCoveringLetterComponent {

  today: Date = new Date();
  @ViewChild('htmlContent') htmlContent: ElementRef;
  allPDF: Array<any> = []

  // table array
  data = [
    {
      id: '1',
      filename: 'file1.pdf'
    },
    {
      id: '2',
      filename: 'file2.pdf'
    },
    {
      id: '3',
      filename: 'file3.pdf'
    }
  ]

  bankcoveringList = []

  // pdf array
  bankcovering = []
  htmlArray = []
  CompanyList = []
  LoginId: string;
  G_UserType: number;
  G_LoginId: string;
  G_SubbrokerCode: string;
  G_ROLEID: number;
  EmpCode: string;
  CompanyID: any;
  CompanyName : "";
  TotalApplicationAmount : "";
  TotalApplicationRejected : "";
  TotalApplicationCount : "";
  fileName: string;
  Base64Array = []
  DIVHtml: any;
  BankName: any;
  BranchName: any;
  isLastFile: boolean;



  constructor(private location: Location,private IPOServiceService : IPOServiceService, private EncrdecrService : EncrdecrService,private Loader: CustomLoaderService,private datePipe: DatePipe,private fb: FormBuilder,) {


  }

  ngOnInit() {
    debugger
    this.BindCompanyList();
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 2) {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      this.G_SubbrokerCode = this.EncrdecrService.getDecr(sessionStorage.getItem('Hldq31TLYwRbLJ8'));
    }
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 1) {

      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      this.EmpCode = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
      this.G_ROLEID = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC')));
    }
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 3) {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      //this.PANNO = this.EncrdecrService.getDecr(sessionStorage.getItem('Hldq31TLYwRbLJ8'));
      //console.log(this.PANNO);
    }
  }

  ngAfterViewInit() {
    $("select").select2();
    $('.CustomSelectCompany').on('change', (e: any) => this.OnChangeCompany(e));

  }

  OnChangeCompany(e : any){
    let ID = e.target.value;
    this.CompanyID = ID;
     this.BindBankCoveringList(this.CompanyID,'CompanyId')
  }

  BindCompanyList(){
    this.IPOServiceService.BindNCDList().subscribe((res : any)=>{
      let data = JSON.parse(this.EncrdecrService.getDecr(res))
      this.CompanyList = data.ArrayOfResponse
    })
  }

  calldatatable() {
    $("#dataTable_tally_sheet").DataTable().clear().draw();
    $('#dataTable_tally_sheet').DataTable().destroy();
    $(document).ready(function () {
      $('#dataTable_tally_sheet').DataTable({
        paging: false,
        searching: false,

        columnDefs: [

        ],

      });

    });
  }



  savePdf(pdfOutput, filename) {

    const pdfBlob = new Blob([pdfOutput], { type: 'application/pdf' });
    const pdfFile = new File([pdfBlob], filename, { type: 'application/pdf' });

    const folderPath = this.location.path(); // Specify the folder path
    console.log("current folder path: ", folderPath)
    const pdfFilePath = folderPath + '/' + filename;
    console.log(" pdf folder path: ", pdfFilePath)

    FileSaver.saveAs(pdfFile)

    // Example: Saving PDF to a specific folder
    // savePdf(pdfOutput, 'bank-covering-letter.pdf');
  }

  convertToZip(pdfOutput, opt) {
    // Create a zip file containing the PDF file
    const zip = new JSZip();
    zip.file(opt.filename, pdfOutput);

    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Create a Blob URL for the zip file
      const zipFileBlob = new Blob([content]);
      // Offer the zip file for download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(content);
      // Append the download link to the document body
      document.body.appendChild(link);
      link.download = 'bank-covering-letter.zip';
      const suggestedFilename = `${opt.filename}.zip`;
      FileSaver.saveAs(content, suggestedFilename);
      link.click();
      document.body.removeChild(link);
    }).catch((error) => {
      console.error("Error generating zip file:", error); // Log error if zip generation fails
    });
  }


 downloadcoveringletter(id: any,flag : any) {
  this.Base64Array = [];
    if(!isNullOrUndefined(this.CompanyID)){
      let currentCompany = this.CompanyList.filter((element)=>{
        if(element.VALUEFIELD == this.CompanyID)
        {
          return element.TEXTFIELD;
        }
      })
      this.fileName = currentCompany[0].TEXTFIELD + ' BankCovering'
      let request : any;
      if(flag == 'New'){
        request = {
          UserType:this.G_UserType,
          CompanyID : this.CompanyID,
          UserId : this.LoginId,
          FileName : this.fileName,
          Flag : "GetNewBankCoveringData"
        }
      }
      else if (flag == 'ByLotNo'){
        request = {
          UserType:this.G_UserType,
          CompanyID : this.CompanyID,
          UserId : this.LoginId,
          LotID : id,
          Flag : "GetDataByLotNo"
        }
      }
      this.Loader.show();
      this.IPOServiceService.GetBankCoveringLetterData(request).subscribe((res : any)=>{
        debugger
        // this.Loader.hide();
        let data = JSON.parse(this.EncrdecrService.getDecr(res))
        console.log(data)
        if(data.ArrayOfResponse.length>0){
          let AllData = data.ArrayOfResponse;
          let CompanyData = data.ArrayOfResponse2;
          let HtmlArrays = CompanyData[0].htmlArrays
          console.log(HtmlArrays);

          HtmlArrays = HtmlArrays.map((element,index)=>{
            let HTMLString : string = element.Html
            element.Html = HTMLString.replace("[Logo]","<img _ngcontent-ntn-c136='' src='../assets/images/IIFL_Logo_reports.png' alt='Logo'>")
            return element;
          })

          let newContent =  document.getElementById("htmlContent");
          let isLastFile = false;
          for(let i=0;i<HtmlArrays.length;i++){
            newContent.innerHTML = HtmlArrays[i].Html;
            console.log("Inner Html : ",newContent.innerHTML)
            if(i==HtmlArrays.length-1){
              isLastFile = true;
            }
            this.exportAsZip("htmlContent",HtmlArrays[i].FileName,isLastFile)
          }

          if(flag == "New"){
            this.BindBankCoveringList(this.CompanyID,"CompanyId");
          }


        }
        else{
          this.Loader.hide();
          this.CallAlertModal("No Applications found.")
        }


      })

    }
    else{
      this.CallAlertModal("Please Select Company.")
    }
  }

  CallAlertModal(msg: any) {
    $("#AlertModal").modal({ backdrop: "static", keyboard: false });
    $("#AlertModalContent").text(msg);
  }



  exportAsZip(div_id,fileName,isLast)
  {
    let data = document.getElementById(div_id);
    // html2canvas(data).then(canvas => {
    //   const contentDataURL = canvas.toDataURL('image/png')
    //   let pdf = new jspdf('p', 'mm', 'a4'); //Generates PDF in landscape mode
    //   // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
    //   // pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);
    //   const pageWidth = 210;
    //   const pageHeight = 297;
    //   const height = canvas.height*pageWidth/canvas.width
    //    pdf.addImage(contentDataURL, 'PNG', 0, 0,pageWidth,height);
    //   // pdf.save(`${fileName}}.pdf`);
    //   const base64Pdf = pdf.output('datauristring');

    //   this.Base64Array.push({'FileName':fileName,'Base64Content':base64Pdf})
    //   let newContent =  document.getElementById("htmlContent");
    //   newContent.innerHTML = "";

    //   if(isLast){
    //     let pdfDATA = {
    //       base64PDFLists:this.Base64Array,

    //     }
    //     this.IPOServiceService.StoreFileAndGenerateZip(pdfDATA).subscribe((res)=>{
    //       debugger
    //       this.Loader.hide();
    //       let response = JSON.parse(this.EncrdecrService.getDecr(res))
    //       let Base64Data = response.ArrayOfResponse[0].Base64ZipFile;
    //       let FileName = `BankCoveringLetter_${this.parseDateToDdmmyy(this.today)}`
    //       this.downloadZip(Base64Data,FileName);
    //     })
    //   }

    // });

    let pageHeight = 0
    let pageWidth = 0
    pageHeight = Math.max(data.clientHeight)
    pageWidth = Math.max(data.clientWidth)
    var opt = {
      filename: fileName,
      image: { type: 'jpeg', quality: 5 },
      html2canvas:  { scale: 2 },
      jsPDF: {format:[pageHeight+20,pageWidth],unit:"px",orientation: 'landscape'},
      pagebreak: { before: '.newPage', avoid: ['.XYZCont'],mode:['avoid-all', 'css', 'legacy'] }
    };
    html2pdf().from(data).set(opt).outputPdf().then((pdf)=> {
        // This logs the base64 string
        debugger
        let pdfdata = "data:application/pdf;base64, "+btoa(pdf)

        this.Base64Array.push({'FileName':fileName,'Base64Content':pdfdata})
      let newContent =  document.getElementById("htmlContent");
      newContent.innerHTML = "";

      if(isLast){
        let pdfDATA = {
          base64PDFLists:this.Base64Array,

        }
        this.IPOServiceService.StoreFileAndGenerateZip(pdfDATA).subscribe((res)=>{
          debugger
          this.Loader.hide();
          let response = JSON.parse(this.EncrdecrService.getDecr(res))
          let Base64Data = response.ArrayOfResponse[0].Base64ZipFile;
          let FileName = `BankCoveringLetter_${this.parseDateToDdmmyy(this.today)}`
          this.downloadZip(Base64Data,FileName);
        })
      }
      });
  }






  downloadZip(base64Data: string, fileName: string) {
    // Decode Base64 string to binary data
    const binaryData = atob(base64Data);
    const byteArray = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i);
    }

    // Create Blob object from binary data
    const blob = new Blob([byteArray], { type: 'application/zip' });

    // Create URL for the Blob object
    const blobUrl = URL.createObjectURL(blob);

    // Create anchor element
    const anchorElement = document.createElement('a');
    anchorElement.href = blobUrl;
    anchorElement.download = fileName;

    // Programmatically click the anchor element to trigger the download
    anchorElement.click();

    // Clean up
    URL.revokeObjectURL(blobUrl);
  }

  parseDateToDdmmyy(date: Date): string {
    // Use DatePipe to format the date to 'ddMMyy'
    const formattedDate = this.datePipe.transform(date, 'ddMMyyyy');

    // Extract day, month, and year from the formatted date
    const day = formattedDate.slice(0, 2);
    const month = formattedDate.slice(2, 4);
    const year = formattedDate.slice(4, 6);

    // Concatenate day, month, and year in the desired order
    return day + month + year;
  }


  BindBankCoveringList(CompanyID,Flag){
    debugger


    let ApplicationNo = $('#ApplicationNo').val()
    let request: any;
    if(Flag=="CompanyId" || isNullOrUndefined(ApplicationNo)){
      this.bankcoveringList = [];

      request = {
        UserType:this.G_UserType,
        CompanyID : this.CompanyID,
        UserId : this.LoginId,
        Flag : "GetDataByCompanyId"
      }
    }
    else{
      request = {
        UserType:this.G_UserType,
        CompanyID : this.CompanyID,
        ApplicationNo : ApplicationNo,
        UserId : this.LoginId,
        Flag : "GetDataByApplicationNo"
      }
    }

// this.Loader.show();
if(Flag == "ApplicationNo" && isNullOrUndefined(this.CompanyID))
{
  this.CallAlertModal("Please select Company")
}
else{
  this.IPOServiceService.GetBankCoveringLetterData(request).subscribe((res : any)=>{
    // this.Loader.hide();
    let data = JSON.parse(this.EncrdecrService.getDecr(res))
    console.log(data)
    this.bankcoveringList = data.ArrayOfResponse;
    this.calldatatable()
  })
}

  }


}
